module.exports = __webpack_public_path__ + "img/ico-transport.324fc731.svg";